import { subdomainTypes } from "../../../../context/availableSubdomains";

type AddressFormValidationInput = {
  form: {
    ship_to_name: string;
    address_line1: string;
    address_city: string;
    address_postcode: string;
    state?: string;
  };
  branch: subdomainTypes | "";
  addressSelected: boolean;
};

export const isAddressFormValid = ({
  form,
  branch,
  addressSelected,
}: AddressFormValidationInput): boolean => {
  if (!form.ship_to_name || form.ship_to_name.trim() === "") {
    return false;
  }

  if (branch === "ca") {
    return Boolean(
      form.address_line1.trim() !== "" &&
        form.address_city.trim() !== "" &&
        form.state &&
        form.state.trim() !== "" &&
        form.address_postcode.trim() !== "",
    );
  }

  return Boolean(
    addressSelected &&
      form.address_line1.trim() !== "" &&
      form.address_city.trim() !== "" &&
      form.address_postcode.trim() !== "",
  );
};
